import { KeywordsPage } from "./pages/keywords.page"
import { NgModule } from "@angular/core"
import { Routes, RouterModule } from "@angular/router"
import { NewKeywordPage } from './pages/new-keyword.page'
import { EditKeywordPage } from './pages/edit-keyword.page'
import { CanDeactivateKeywordPage } from './guards/can-deactivate-keyword-page'
import { ContentTypeGuard } from './guards/content-type.guard'
import { EditRequestPage } from './pages/edit-request.page'
import { AdminUploadPage } from "./pages/admin-upload/admin-upload.page"
import { BulkUploaderGuard } from "./guards/can-activate-bulk-uploader.guard"

const routes: Routes = [
  {path: '', component: KeywordsPage},
  {path: 'new/:contentTypeId', component: NewKeywordPage, canActivate: [ ContentTypeGuard ], canDeactivate: [ CanDeactivateKeywordPage ]},
  {path: ':keywordId/edit', component: EditKeywordPage, canDeactivate: [ CanDeactivateKeywordPage ] },
  {path: 'request/:requestId/edit', component: EditRequestPage, canDeactivate: [ CanDeactivateKeywordPage ] },
  {path: 'admin_upload', component: AdminUploadPage, canActivate: [ BulkUploaderGuard ]}
]

export const providers = [
  CanDeactivateKeywordPage
]

@NgModule({
  imports: [ RouterModule.forChild(routes) ],
  exports: [ RouterModule ],
  providers: providers
})
export class KeywordsRoutingModule {}
